import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ account, project }) => {
    repository.getProjectSynthesis(project);

    return present(
      repository
        .getProjectSynthesis(project)
        .then((synthesis) => ({
          project,
          account,
          synthesis,
        }))
        .catch((e) => Promise.reject({ project, account })),
    );
  };
}

export type { Interactor };

export { createInteractor };
